import { Tooltip, UIHeading2, UIHeading3, useDeviceType } from '@cian/ui-kit';
import * as style from './FaqItem.css';
import classnames from 'classnames';
import { IFaqItem } from 'shared/types/faq';
import { openPrice } from '../tracking';

interface IFaqItemProps extends IFaqItem {
  onChangeVisible: VoidFunction;
  visible: boolean;
}

export const FaqItem: React.FC<IFaqItemProps> = ({ id, title, answer, visible, onChangeVisible }) => {
  const device = useDeviceType();

  const isTablet = device !== 'desktop';

  const Title = isTablet ? UIHeading3 : UIHeading2;

  return (
    <div className={classnames(style['container'], isTablet && style['container-tablet'])}>
      <div className={style['title-container']} onClick={onChangeVisible}>
        <div className={style['title']}>
          <Title>{title}</Title>
        </div>
        <div className={classnames(style['open-button'], visible && style['openned'])} />
      </div>
      <div className={classnames(style['answer'], !visible && style['hidden'])}>
        {id === 1 && (
          <>
            Бесплатно — первые публикации в каждой новой категории, кроме коммерческой: продажа квартиры, продажа дома и
            т.д. Проверьте условия для своего региона в разделе{' '}
            <a
              onClick={openPrice}
              className={style['link']}
              href="https://www.cian.ru/price/"
              rel="noreferrer"
              target="_blank"
            >
              «Прайс»
            </a>
            .
          </>
        )}
        {id === 5 && (
          <>
            Это зависит от расположения, района, цены и многого другого. У собственников уходит, в среднем, до 3 месяцев
            на продажу квартиры и до 1,5 на поиск арендатора. Посмотрите в наших материалах,{' '}
            <a
              className={style['link']}
              href="https://www.cian.ru/stati-kak-bystro-prodat-kvartiru-283715/"
              rel="noreferrer"
              target="_blank"
            >
              как продать выгоднее
            </a>{' '}
            или{' '}
            <a
              className={style['link']}
              href="https://www.cian.ru/stati-kak-sdat-kvartiru-bez-posrednikov-288643/"
              rel="noreferrer"
              target="_blank"
            >
              сдать быстрее
            </a>
            .
          </>
        )}
        {id === 6 && (
          <>
            Да, коммерческую тоже{' '}
            <a
              className={style['link']}
              href="https://hc.cian.ru/hc/ru/articles/360058930771-%D0%9A%D0%B0%D0%BA-%D0%BE%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D0%BA%D0%BE%D0%B2%D0%B0%D1%82%D1%8C-%D0%BA%D0%BE%D0%BC%D0%BC%D0%B5%D1%80%D1%87%D0%B5%D1%81%D0%BA%D1%83%D1%8E-%D0%BD%D0%B5%D0%B4%D0%B2%D0%B8%D0%B6%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C-%D0%BE%D1%82-%D1%81%D0%BE%D0%B1%D1%81%D1%82%D0%B2%D0%B5%D0%BD%D0%BD%D0%B8%D0%BA%D0%B0"
              rel="noreferrer"
              target="_blank"
            >
              можно продать и сдать
            </a>
            : офис, коворкинг, склад, торговую площадь, здание, целое производство, готовый бизнес и даже коммерческую
            землю. Для этого{' '}
            <a
              className={style['link']}
              href="https://www.cian.ru/razmestit-obyavlenie/"
              rel="noreferrer"
              target="_blank"
            >
              разместите объявление
            </a>{' '}
            с подходящим типом недвижимости.
          </>
        )}
        {id === 7 && (
          <>
            <h3>Бесплатно</h3>
            <div>
              <div>Достаточно интересно и подробно рассказать про объект, добавить качественные фото и видео.</div>
              <div>
                А за заполнение некоторых полей мы добавим на объявление значки — они привлекут больше внимания.
              </div>
            </div>
            <h3>Платно</h3>
            <div>
              Используйте продвижение{' '}
              <a
                href="https://support.cian.ru/ru/knowledge_base/art/94/cat/19/#h_01FJKQ9ZCKDTER62M4724FAAS6"
                rel="noreferrer"
                target="_blank"
                className={style['link']}
              >
                Стандарт, Премиум, Топ
              </a>{' '}
              или дополнительную ставку выше Топа. У каждого способа есть свои преимущества: чем дороже — тем выше будет
              объявление в поиске и тем больше получит просмотров и звонков
            </div>
          </>
        )}
        {id === 8 && (
          <>
            Мы покажем в объявлении временный номер вместо реального: <br />
            <ul>
              <li>ваш номер не попадёт в базы мошенников и спам-базы;</li>
              <li>вам будут звонить, только пока объявление опубликовано.</li>
            </ul>
            Если вы собираетесь сдать квартиру, можно получать анкеты вместо звонков
            <Tooltip
              theme="white"
              title="Анкеты от жильцов в аренде пока только в регионах: Москва и область, Санкт-Петербург и область,
            Краснодарский край, Нижегородская область, Ростовская область, Самарская область, Свердловская область,
            Татарстан."
            >
              <div className={style['tooltip']} />
            </Tooltip>
            . Для этого при публикации объявления выберите «Скрыть номер телефона». Потенциальные жильцы заполнят
            небольшую анкету-заявку и смогут связаться с вами только после одобрения анкеты в личном кабинете. Читайте
            подробнее,{' '}
            <a
              href="https://hc.cian.ru/hc/ru/articles/4406218261908-%D0%9A%D0%B0%D0%BA-%D0%BF%D0%BE%D0%BB%D1%83%D1%87%D0%B0%D1%82%D1%8C-%D0%B0%D0%BD%D0%BA%D0%B5%D1%82%D1%8B-%D0%B2%D0%BC%D0%B5%D1%81%D1%82%D0%BE-%D0%B7%D0%B2%D0%BE%D0%BD%D0%BA%D0%BE%D0%B2-"
              rel="noreferrer"
              target="_blank"
              className={style['link']}
            >
              как подключить анкеты
            </a>
            .
          </>
        )}
        {![1, 5, 6, 7, 8].includes(id) && answer}
      </div>
    </div>
  );
};
